import { httpClient } from '../../../http-client';
import { ApiUrlBuilder } from '../../shared/constants/apiUrl';
import { AttributeModel, DomainValueModel } from '../models/attribute.model';
import { GetAttributeView, UpdateAttributeView } from '../types/attribute.type';
import { getCause } from '../../../http-client/interceptors/error.interceptor';

const AttributeFloorServiceImplementation = {
  getAttributes: (orga: string, siteId: string, buildingId: string, floorId: string, assetId: string = ""): Promise<AttributeModel[]> =>
    httpClient
      .get(ApiUrlBuilder.getAttributes(orga, siteId, buildingId, floorId, assetId))
      .then((response) => response.json())
      .then((response) => {
        if (Array.isArray(response)) {
          return response.map((attributeView: unknown) => {
            const isGetAttributeView = (getAttributeView: any): getAttributeView is GetAttributeView =>
              'id' in getAttributeView &&
              'componentId' in getAttributeView &&
              'name' in getAttributeView &&
              'value' in getAttributeView &&
              'type' in getAttributeView &&
              'isEditable' in getAttributeView &&
              'domainValues' in getAttributeView;
            if (isGetAttributeView(attributeView)) {
              return new AttributeModel(
                attributeView.id,
                attributeView.componentId,
                attributeView.name,
                attributeView.value,
                attributeView.type,
                attributeView.isEditable,
                attributeView.domainValues.map((domainValue) => (
                  new DomainValueModel(
                    domainValue.rank,
                    domainValue.code,
                    domainValue.value
                  )
                )));
            } else {
              throw new Error(`response contains: ${ JSON.stringify(response) }`, { cause: getCause( 500) });
            }
          });
        } else {
          throw new Error(`response contains: ${ JSON.stringify(response) }`, { cause: getCause(response?.status || 500) });
        }
      }),
  updateAttribute: (
    orga: string,
    componentId: string,
    attributeId: string,
    updateAttributeView: UpdateAttributeView
  ): Promise<Response> =>
    httpClient.put(ApiUrlBuilder.updateAttribute(orga, componentId, attributeId), {
      body: JSON.stringify(updateAttributeView),
    }),
};

export const AttributeFloorService: Readonly<typeof AttributeFloorServiceImplementation> =
  AttributeFloorServiceImplementation;

const AttributeOutdoorAreasServiceImplementation = {
  getAttributes: (orga: string, siteId: string, assetId: string = "") => AttributeFloorService.getAttributes(orga, siteId, siteId, siteId, assetId),
  updateAttribute: (orga: string, componentId: string, attributeId: string, updateAttributeView: UpdateAttributeView) =>
    AttributeFloorService.updateAttribute(orga, componentId, attributeId, updateAttributeView),
};

export const AttributeOutdoorAreasService: Readonly<typeof AttributeOutdoorAreasServiceImplementation> =
  AttributeOutdoorAreasServiceImplementation;
